import queryString from 'query-string'
import apiClient from './api-client'

function list(practiceId, checkDate, page, query, perPage) {
  const options = { withHeaders: true }
  const queryParams = page === 'all' ? { all: true } : { page }

  if (checkDate) queryParams.date = checkDate
  if (query) queryParams.query = query
  if (perPage) queryParams.per_page = perPage

  return apiClient.get(
    queryString.stringifyUrl({
      url: `/practices/${practiceId}/in-office-billing-orders`,
      query: queryParams,
    }),
    options,
  )
}

function listCPTCodes(practiceId) {
  const options = { withHeaders: true }

  return apiClient.get(
    queryString.stringifyUrl({
      url: `/practices/${practiceId}/billing-orders/office/cpt-codes`,
    }),
    options,
  )
}

const InOfficeBillingOrders = {
  list,
  listCPTCodes,
}

export default InOfficeBillingOrders
